import { SubContractor } from "@/services/api";
import { useState } from "react";

export const useSearch = (subContractors: SubContractor[] = []) => {
  const [searchValue, setSearchValue] = useState("");

  const filter = (list: SubContractor[], query: string): SubContractor[] => {
    const trimmed = query.trim();

    if (!trimmed) {
      return list;
    }

    const normalizedQuery = trimmed.toLowerCase();

    return list.filter(item => {
      const name = (item?.CompanyNameEn ?? "").toLowerCase();
      const id = String(item?.CompanyNo ?? "").toLowerCase();
      const license = (item?.TradeLicenseNumber ?? "").toLowerCase();

      return (
        name.includes(normalizedQuery) ||
        id.includes(normalizedQuery) ||
        license.includes(normalizedQuery)
      );
    });
  };

  const filteredSubContractors = filter(subContractors, searchValue);

  return { searchValue, setSearchValue, filteredSubContractors };
};
